import * as React from 'react'
import Modal from 'embed/components/Modal'
import { Fields } from 'embed/constants/fields'
import { ApplicationField } from 'embed/components/ApplicationField/container'
import EmailSubmitButton from 'embed/components/ApplicationSubmitButton'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import classnames from 'classnames'
import { css } from 'emotion'
import { Product, TrackingKey } from 'even-ts-static'
import Tracker from 'common/services/Tracker'

const styles = require('./styles')

export interface QuoteModalProps {
  isLoading: boolean
  isValid: boolean
  handleRemarketingEmailSubmitted: () => void
  handleRemarketingEmailDeclined: () => void
}

export const QuoteModal: React.FC<QuoteModalProps> = ({
  isLoading,
  isValid,
  handleRemarketingEmailSubmitted,
  handleRemarketingEmailDeclined,
}) => {
  React.useEffect(() => {
    Tracker.trackEvent({
      action: TrackingKey.LifeInsuranceRemarketingModalShown,
      data: {},
      timestamp: new Date(),
    })
  }, [])

  return (
    <Modal className={styles.modalContainer}>
      <div className={styles.modalHeader}>
        <h5>Save your quotes to your inbox</h5>
        <h6>
          Enter your email and we'll send you a copy of your personalized life insurance policy quotes for you to review
          later.
        </h6>
      </div>
      <div className={styles.modalContent}>
        <div className={styles.modalInput}>
          <ApplicationField product={Product.LifeInsurance} field={Fields.EmailAddress} />
        </div>
        <ThemeConsumer>
          {({ fontFamilyPrimary }) => (
            <>
              <div className={styles.buttonContainer}>
                <EmailSubmitButton
                  fullWidth={true}
                  isValid={isValid}
                  onSubmit={() => {
                    Tracker.trackEvent({
                      action: TrackingKey.LifeInsuranceRemarketingEmailSubmitted,
                      data: {},
                      timestamp: new Date(),
                    })
                    handleRemarketingEmailSubmitted()
                  }}
                  loading={isLoading}
                >
                  Send me my quotes
                </EmailSubmitButton>
                <p
                  className={classnames(
                    styles.button,
                    css(`
                      font-family: ${fontFamilyPrimary};
                    `),
                    'decline-remarketing',
                  )}
                  // tslint:disable-next-line: jsx-no-lambda
                  onClick={() => {
                    Tracker.trackEvent({
                      action: TrackingKey.LifeInsuranceRemarketingEmailDeclined,
                      data: {},
                      timestamp: new Date(),
                    })
                    handleRemarketingEmailDeclined()
                  }}
                >
                  No, don't email me my quotes
                </p>
              </div>
              <div className={styles.disclaimerContainer}>
                <p>
                  By clicking “Send Me My Quotes” you are agreeing to be contacted via email by Even Financial and its
                  owned and affiliated companies, such as LeapLife, to receive your quotes and to explore other
                  financial products and services. Entering your email now is not a required condition to see your
                  quotes or to proceed toward obtaining life insurance.
                </p>
              </div>
            </>
          )}
        </ThemeConsumer>
      </div>
    </Modal>
  )
}
